export const duTexts = {
  // Titles
  encyclopediaTitle: "Ghalichin Enzyklopädie",
  insuranceAndServicesTitle: "Ghalichin Versicherung und Dienstleistungen",
  generatorTitle: "Ghalichin Generator",
  home: "Zuhause",
  contactUs: "kontaktiere uns",
  loginRegister: "Anmeldung/ Registrieren",
  encyclopedia: "Enzyklopädie",
  vr: "virtuelle Realität",
  buy: "Kaufen",
  loading: "Wird geladen",
  rugGenerate: "Teppichlayout",
  insuranceAndServices: "Versicherung und Dienstleistungen",
  insurance: " Versicherung",
  brand: "Marke",
  shaneh: "Teppich Schilf",
  density: "Dichte",
  yarn: "Garn",
  rug_size_6: "Teppichgröße 6",
  rug_size_9: "Teppichgröße 9",
  rug_size_12: "Teppichgröße 12",
  decoration: "Dekoration",
  room_services: "Zimmerservice",
  floor_covering: "Bodenbelag",
  wall: "Wand",
  roof: "Dach",
  selectImage: "Bild auswählen",
  wishListText:
    "Sie können die erstellten Teppiche zur Favoritenliste hinzufügen, um später eine Vorschau davon zu sehen.",
  services: "Dienstleistungen",
  specialPosts: "spezielle Beiträge",
  preview: "Vorschau",
  lachakToranj: "Lachak Toranj",
  modern: "modern",
  afshan: "afshan",
  kheshti: "kheshti",
  border: "Rand",
  corner: "Ecke",
  background: "Hintergrund",
  toranj: "Toranj",
  tile: "Fliese",
  pattern: "Muster",
  rugSettings: "Fliese",
  wishList: "Wunschzettel",
  addToWishList: "zur Wunschliste hinzufügen",
  listIsEmpty: "Liste ist leer",
  rotate: "drehen",
  clear: "klar",
  latest: "neueste",
  oldest: "älteste",
  onSale: "im Angebot",
  searchingForSellers: "Suche nach Verkäufern",
  storesForThisRug: "speichert für diesen Teppich",
  noStoreForSelectedRug: "Kein Geschäft für ausgewählten Teppich",
  selectOneSimilarRug: "Wählen Sie einen ähnlichen Teppich",
  selectedRugs: "ausgewählte Teppiche",
  rugSimilarityPercentage: "Teppich Ähnlichkeit Prozentsatz",
  similarRugs: "ähnliche Teppiche",
  availableRugSizes: "verfügbare Teppichgrößen",
  phoneNumber: "Telefonnummer",
  address: "Adresse",
  filters: "Filter",

  previewEmptyHelpText:
    "Sie müssen der Liste mindestens einen Teppich hinzufügen",

  // Texts

  landingText: `Die Schaffung eines Mehrwerts für den Kaufprozess ist eines der Hauptanliegen eines jeden Unternehmens. Dieser Mehrwert kann auf drei Arten untersucht und umgesetzt werden. Aus Sicht des Verbrauchers, des Verkäufers und letztendlich des Herstellers. Ziel von Ghalichin ist es, diesen Mehrwert in einer digitalen und sicheren Plattform zu schaffen. Unser Ansatz ist es, den Verkauf und Kauf von"Teppichwaren" in einer neuen und zuverlässigen Umgebung anzubieten.`,

  wikipediaBoldText: `Was ist der Unterschied zwischen maschinell hergestellten und handgeknüpften Teppichen? Worauf sollte ich bei der Auswahl eines hochwertigen Teppichs achten? Wie wähle ich die Größe des Teppichs? Was ist die richtige Teppichfarbe für mein Dekor? Was bedeutet Kamm und Dichte in einem Autoteppich? Was bedeutet Raj in Handknoten?`,

  wikipediaLightText: `Ausreichende Informationen vor dem Kauf sind eine der Voraussetzungen für den Kauf eines Produkts. Ghalichin in der Enzyklopädie versucht, Ihre Fragen zu beantworten und die genauesten Informationen über Material, Design, Eleganz, Fasern, Farbe, Abmessungen und Design des Teppichs und Teppichs bereitzustellen`,
  layOutBoldText: `Wie war die Form der Teppich-Bergamotte meines Nachbarn? Stimmen Sie zu, dass der Hintergrund ihrer Teppiche für unsere Wohnkultur sehr gut geeignet war? `,

  layOutLightText: `Teppichlayout ist unser besonderer und exklusiver Service für diejenigen, die daran interessiert sind, mit den Details ihres Teppichs zu spielen, den Teppich zu finden, der ihrer Wahl am nächsten kommt, und ihn aus dem nächsten Teppich vorzubereiten, um ihren Wohnsitz zu lösen`,
  VRBoldText: `ch wünschte, wir würden sagen, bringen Sie alle vier Teppiche nach Hause und wir werden einen auswählen. Passt ein moderner Teppich mehr zu unserem Dekor oder zu einem traditionellen? `,

  VRLightText: `Es mag Ihnen passiert sein, dass Sie beim Kauf von Teppichen einige der Designs mögen, aber es ist Ihnen nicht möglich, alle diese Teppiche in Ihrem Haus zu verteilen und ihr Aussehen mit Ihrer Heimdekoration zu sehen und die beste Option zu wählen.Ghalichin hat viele Ideen für Ihr Bedürfnis. Die Simulation Ihres Hauses ist der Anfang dieses Weges und wird fortgesetzt`,
  shoppingBoldText: `Weißt du, von wem du kaufst? Kann man ihm vertrauen, ist es kein Betrug? Schicken sie den Teppich? Ist es nicht besser, persönlich zu kaufen?`,

  shoppingLightText: `Die Schaffung einer sicheren Plattform für den Handel war schon immer ein Anliegen von Verbrauchern und Verkäufern. Das Vertrauen in das Online-Verkaufsumfeld ist weitaus komplexer, und dies ist eines der Hindernisse für die Expansion dieses Marktes, insbesondere für wertvolle Produkte. Galichin hat versucht, eine sichere und zuverlässige Verkaufsplattform für den Kauf von Teppichen für Verbraucher und den Verkauf von Teppichen für Lieferanten bereitzustellen, indem geeignete Mechanismen geschaffen wurden`,

  insuranceBoldText: `Ich wünschte, der Verkäufer würde den Teppich regelmäßig waschen? Wo kann ich den Teppich waschen, damit er nicht verderbt? Ich wünschte, sie würden unseren alten Teppich nehmen und ihn für eine bestimmte Menge durch einen neuen ersetzen!Gibt es einen Ort, an dem ich einen Teppich mieten kann? Mieten sie neue Teppiche?`,

  insuranceLightText: `Der Kundendienst und die Garantie für wertvolle Waren wie Teppiche machen das Einkaufen für jeden Kunden angenehmer und sicherer. Entsprechend den Kundenbedürfnissen bietet Ghalichin neben verschiedenen Kundendienstleistungen auch andere wertvolle Dienstleistungen an. Dienstleistungen wie kostenloses Waschen! Ersetzen Sie Ihren alten Teppich durch einen neuen! Und Teppichverleih für den kurzfristigen Einsatz von Teppichen !!! `,

  insuranceText: `Wir sind alle daran interessiert, an einem Ort zu kaufen, der uns sowohl zum Zeitpunkt des Kaufs als auch des Kundendienstes die besten Optionen bietet. Ghalichin bietet diesbezüglich auch eine Vielzahl von Dienstleistungen an. Zum Beispiel den Verbraucher. Eine Person, die gekauft hat Der versicherte Teppich von Ghalichin kann vom ersten kostenlosen Waschen seines Teppichs profitieren oder nach einer Weile erhält er einen neuen Teppich, indem er einen Teil der Kosten bezahlt. Der Teppichverleih ist ein weiterer Service, der in Kürze eingeführt wird`,

  servicesText: `Wir sind alle daran interessiert, an einem Ort zu kaufen, der uns sowohl zum Zeitpunkt des Kaufs als auch des Kundendienstes die besten Optionen bietet. Ghalichin bietet diesbezüglich auch eine Vielzahl von Dienstleistungen an. Zum Beispiel den Verbraucher. Eine Person, die gekauft hat Der versicherte Teppich von Ghalichin kann vom ersten kostenlosen Waschen seines Teppichs profitieren oder nach einer Weile erhält er einen neuen Teppich, indem er einen Teil der Kosten bezahlt. Der Teppichverleih ist ein weiterer Service, der in Kürze eingeführt wird`,
  firstLandingText: `Willkommen auf der virtuellen Reise des Kunden der Qalichin-Site.
  Auf dieser Reise begleiten wir Sie in fünf Abschnitten.
  Der erste Schritt besteht darin, korrekte und zuverlässige Informationen in der Enzyklopädie zu erhalten. Der zweite Schritt besteht darin, den Kauf eines Teppichs für Sie mit einem Teppichvermittlungsservice attraktiv zu machen, mit dem Sie den Teppich personalisieren können. Jetzt, im dritten Schritt oder der virtuellen Realität, gehen wir für mehr Sicherheit und einen sichereren virtuellen Kauf zu zweidimensionalen und dreidimensionalen Simulatoren, wo Sie den Teppich harmonischer mit der Dekoration Ihres Hauses vorbereiten können. sehr gut. Sie haben Ihre Wahl getroffen, jetzt ist es an der Zeit, den Preis zu zahlen. Der vierte Schritt beim Kauf von Teppichen ist der Teppichmarkt, wo Sie den besten Preis vom nächstgelegenen Ort finden und eine Bestellung aufgeben.  Herzlichen Glückwunsch, Sie wurden dem Stamm der Qalichin hinzugefügt. Ja, das ist richtig, der fünfte Schritt dieser Reise beginnt nach Ihrem Kauf.Der fünfte Schritt sind die Versicherungen und Dienstleistungen, die unsere Verpflichtungen Ihnen gegenüber, einem neuen Mitglied von Qalichin, darstellen.
  Wir freuen uns sehr, dass Sie sich für Qalichin entschieden haben und unser Reisebegleiter geworden sind
  Wir hoffen, Sie haben einen guten Einkauf und genießen Ihre Reise.
  Wählen Sie den gewünschten Abschnitt in der Symbolleiste oben aus.`,
  encyclopediaEndText: `Enzyklopädie:
  <br/>
  Vom Stoff zum Muster
  <br/>
  Der erste Schritt eines jeden Kaufs besteht darin, genügend Informationen über das Produkt zu haben.
  Unsere erste Informationsquelle beim Kauf eines Produkts sind seine Verkäufer. Nun stellt sich die Frage, sind alle Informationen, die uns die Verkäufer geben, korrekt und zuverlässig, oder brauchen wir eine zuverlässigere Quelle, um eine Entscheidung treffen zu können?
  Einen Multimedia-Bereich zu haben, um Textilprodukte und Teppiche insbesondere von Herstellern und Verkäufern vorzustellen, und Verbrauchern einen Ort zu bieten, an dem sie ihre Meinungen austauschen und ihre Einkaufserlebnisse ausdrücken können, ist ein starker Punkt für sicheres Einkaufen.
  <br/>
  Einige Beispiele für Wettbewerbsvorteile, die eine solche Plattform bietet: Aus Verbrauchersicht:
  <br/>
  Sind alle Verkäufer ehrlich zu Ihnen?
  Sind alle Informationen, die sie Ihnen geben, korrekt?
  <br/>
  Aus Sicht des Verkäufers:
  <br/>
  Werden die Produkte ihres Ladens optimal vorgestellt?
  Kennt die statistische Gesellschaft sie richtig?
  <br/>
  Aus Produzentensicht:
  Ist der Wettbewerbsvorteil der von ihnen hergestellten Produkte ausreichend eingeführt und bekannt?
  Müssen sie in neueren Räumen eingeführt werden? `,
  generatorEndText: `Teppichanordnung:
  <br/>
  Teppiche und Muster
  <br/>
  Der zweite Schritt für einen sicheren und zuverlässigen Kauf ist es, den Kauf und die Auswahl des Produkts aus Zufriedenheit zu genießen, nicht aus Müdigkeit und Verurteilung oder Entscheidungszwang.
  
  Wir alle kennen den Teppich und seine Gestaltung und Funktion seit seiner Kindheit, je nach kulturellem Hintergrund und Lebensstil
  Diese visuelle Vertrautheit ermöglicht es uns, beim Kauf von Teppichen erfahrene Teppichexperten zu sein
  Wenn es uns allen möglich wäre, bei der Gestaltung von Teppichen selbst Hand anzulegen, würden wir diese Chance auf jeden Fall nutzen.
  Damit wir vielleicht von unserem Teppichdesign zu einem besseren Plan gelangen oder unseren persönlichen Plan auf den Prüfstand stellen und authentische iranische Pläne prüfen. Im Teppich-Layout-Bereich wurde diese reizvolle Möglichkeit für Sie geschaffen, Ihr Design und Muster zu personalisieren und mit dem abwechslungsreichen Spiel der Kartenauswahl leichter zu Ihrem Lieblingsdesign zu gelangen.
  Darüber hinaus ist die Analyse und Überprüfung der Textur Ihrer exklusiven Karte mit ein paar einfachen Faktoren problemlos möglich
  <br/>
  Einige Beispiele für Wettbewerbsvorteile, die eine solche Plattform bietet:
  <br/>
  Aus Verbrauchersicht:
  <br/>
  Marktkarten können geändert und personalisiert werden.
  Die vom Kunden entworfene Karte wird mit den auf dem Markt erhältlichen Karten überprüft und dem Kunden die am nächsten liegenden Karten vorgestellt
  <br/>
  Aus Sicht des Verkäufers:
  <br/>
  Das Spiel, den Kaufprozess zu diversifizieren und den Teppichauswahlprozess attraktiver zu gestalten
  Den Geschmack des Kunden im Kaufprozess teilen und die Auswahl der Teppiche erleichtern
  <br/>
  Aus Produzentensicht:
  <br/>
  Analysieren des Kundengeschmacks anhand ausgewählter Stücke und Ausrichten der Designeinheit auf den Markttrend
  Ziel ist die Produktion und Präsentation der Texturplattform von exklusiven Karten von Kunden in Form einer limitierten Auflage`,
  vrEndText: `virtuelle Realität:
  <br/>
  Teppiche und Dekorationen
  <br/>
  Der dritte Schritt der virtuellen Teppichreise besteht darin, mit 2D- und 3D-Tools zu simulieren und virtuelle Rundgänge für Geschäfte zu erstellen, die möglicherweise nicht in Ihrer Nähe liegen, Sie aber gerne besuchen möchten.
  <br/>
  Eines der Anliegen beim Kauf eines Produktes ist immer die Abstimmung des Produktes mit anderen Haushaltsprodukten
  Jetzt, wo es an der Zeit ist, einen Teppich auszuwählen, wird diese Abstimmung viel wichtiger, denn die Frage der Abstimmung des Teppichs mit der Wohndekoration steht im Mittelpunkt. Eine der Lösungen sind Teppiche in Wohnungen.
  Aber wenn die Anzahl der Pläne groß ist und der Teppichtransport ein Problem darstellt, kommt die Technologie ins Spiel und bietet einfachere Lösungen.
  Einige Beispiele für Wettbewerbsvorteile, die eine solche Plattform bietet: Aus Verbrauchersicht:
  Sehen Sie sich die in den Geschäften angebotenen Produkte an, ohne reisen zu müssen
  Betrachten aller Arten von Teppichdesigns im gewünschten Raum mithilfe von Simulationstools
  <br/>
  Aus Händlersicht:
  <br/>
  Profitieren von Softwareplattformen, um mehr Besucher in ihr Geschäft zu locken
  Verwendung technologischer Systeme zur Senkung der Kosten für Teppichböden im Haus des Kunden
  <br/>
  Aus Herstellersicht:
  <br/>
  Erstellen Sie einen virtuellen Rundgang durch die Fabrik und zeigen Sie Produkte für das Großhandelsnetzwerk
  Verkürzung und Vereinfachung des Bestellvorgangs für Ladenbesitzer, die Schwierigkeiten haben, die Fabrik zu besuchen`,
  buyEndText: `Besorgen:
  <br/>
  Teppiche und Geschäfte
  <br/>
  Der vierte Schritt der virtuellen Reise von Qalichin besteht darin, einen virtuellen Marktplatz oder Marktplatz für Marken bereitzustellen
  <br/>
  Nach den drei vorangegangenen Etappen dieser virtuellen Reise bis zur Kaufphase hat der Kunde Bedenken wie den Preis und die Qualität der ausgewählten Produkte.
  In dieser Situation erscheint es sehr notwendig, von einem Marktplatz zu profitieren, der Preis- und Qualitätsprüfungen sicher und ohne Zeit- und Kostenaufwand durchführen kann.
  Überwachen Sie in diesem Markt die Einkäufe anderer Personen, sehen Sie sich die Kundenzufriedenheit an und stellen Sie den Kundendienst sicher, damit Sie endlich von zu Hause aus in aller Ruhe eine passende Bestellung aufgeben können.
  <br/>
  Einige Beispiele für Wettbewerbsvorteile, die eine solche Plattform bietet: Aus Verbrauchersicht:
  <br/>
  Prüfung des Preises der gewünschten Ware bei mehreren Lieferanten
  Überprüfung der Glaubwürdigkeit und Kundenzufriedenheit von Warenlieferanten anhand der Befragung von Altkäufern
  <br/>
  Aus Händlersicht:
  <br/>
  Präsentieren Sie Ihre Produkte online, ohne Muster oder Lager versenden zu müssen
  Dynamischere Interaktion mit dem Verbraucher und der Start und die Benachrichtigung von Sonderverkäufen
  <br/>
  Aus Herstellersicht:
  <br/>
  Bereitstellung eines Produktportfolios von Herstellerprodukten auf dem Markt ohne Zwischenhändler und Makler
  Erhalten Sie direktes Feedback vom Endverbraucher und steuern Sie die Produktion basierend auf der Marktnachfrage`,
  insuranceEndText: `Versicherungen und Leistungen:
  <br/>
  Teppich und Ruhe
  <br/>
  Der fünfte und letzte Schritt der virtuellen Customer Journey ist die Aufnahme des Käufers in den Qalichini-Clan.
  Verkaufen ist nie das Ende der Geschichte.
  Der Zweck eines Unternehmens besteht nicht darin, ein Produkt zu verkaufen oder einen Kunden zu bedienen und diesen Fluss zu beenden. Wenn dies der Fall ist, kann das Wort erfolgreich nicht dafür verwendet werden.
  Der Zweck der Erstellung dieses Abschnitts ist die Vernetzung. Ein Netzwerk von Diensten und Interaktionen.
  Nach dem Kauf eines Teppichs ergeben sich für den Kunden unterschiedliche Bedürfnisse. Wie das Waschen, das Beheben möglicher Fehler und das Reparieren des Teppichs, das Haben einer Garantie und die Gewährleistung der Qualität und auch nach einer Weile der Nutzung des Teppichs die Notwendigkeit, den gebrauchten Teppich zu verkaufen oder den alten Teppich durch einen neuen Teppich auf dem Markt zu ersetzen . Alle diese Dienstleistungen können erbracht werden, wenn wir den Verkaufsprozess richtig sehen und die notwendigen Plattformen für die Fortsetzung des After-Sales-Service-Prozesses vorbereitet haben.
  Einige Beispiele für Wettbewerbsvorteile, die eine solche Plattform bietet:
  <br/>
  Aus Verbrauchersicht:
  <br/>
  Sicherer und garantierter Kauf aus einer Sammlung mit mehreren Dienstleistungen
  Schaffung einer Plattform für den Gebrauchtmarkt und den Markt für Ersatzteppiche
  <br/>
  Aus Händlersicht:
  <br/>
  Profitieren Sie von einem kohärenten und kontinuierlichen Vertriebsnetz
  Sich gegenüber Kunden als überlegene Serviceeinheit vorstellen und identifizieren
  <br/>
  Aus Herstellersicht:
  <br/>
  In der schnelllebigen und wettbewerbsintensiven Geschäftswelt ist ein besserer und mehr Service gleichbedeutend mit einer besseren und bekannteren Marke
  Ausbau und Ausbau des Kundenclubs`,
  welcome: `Willkommen auf der virtuellen Reise des Kunden der Qalichin-Site. Auf dieser Reise begleiten wir Sie in fünf Teilen.`,
  hande_made: "handgefertigter Teppich",
  machine: "maschinengewebter Teppich",
  first_step: `Der erste Schritt besteht darin,
  die richtigen Informationen zu erhalten
  Es ist zuverlässig in der Enzyklopädie.`,
  scond_step: `Der zweite Schritt besteht darin, den Teppicheinkauf
  für Sie attraktiv zu machen, indem Sie
 Teppichverlegungsdienste anbieten, mit denen Sie den
 Teppich personalisieren können.`,
  market_carpet: "Markt Teppich",
  your_own_carpet: "Ihr Teppich",
  your_photo: "dein Foto",
  third_step: `In der dritten Stufe oder Virtual Reality für mehr Vertrauen und virtuelles Einkaufen
  Wir wählen 2D- und 3D-Simulatoren, mit denen Sie den Teppich harmonischer mit Ihrer Dekoration und Ihrem Zuhause vorbereiten können. sehr gut. Sie haben Ihre Wahl getroffen, jetzt ist es an der Zeit, den Preis zu zahlen.`,
  virtual_tour: "virtuelles reisen",
  threeD: "3D",
  Two_dimensional: "2D",
  fourth_step: `Der vierte Schritt beim Kauf eines Teppichs ist der Teppichmarkt,
  wo Sie den besten Preis im nächsten Einkaufszentrum finden und bestellen können. Herzlichen Glückwunsch, Sie sind der Qalichin-Familie beigetreten.`,
  market: "Market",
  gazette: "Zeitschrift",
  fifth_step: `Die fünfte Etappe dieser Reise beginnt nach Ihrem Einkauf. Der fünfte Schritt sind Versicherungen und Dienstleistungen, die unsere Verpflichtungen Ihnen gegenüber, dem neuen Mitglied von Qalichin, darstellen.`,
  secondhand: "Gebraucht",
  replace: "Teppich ersatz",
  inshurance: "Versicherung",
  size_selection: "Größe",
  select_image: "Foto auswählen",
  confirm_and_pay: "bestätigen und bezahlen",
  selection_size_description:
    "Bitte wählen Sie eine der gewünschten Teppichgrößen aus",
  image_registration: "Bildregistrierung",
  zoom: "Vergrößerung",
  confirmation_and_approval: "Bestätigen und fortfahren",
  name_and_lastname: "Vorname und Nachname",
  Phone_call: "Anruf",
  Address: "Adresse",
  send: "die Bezahlung",
  ordering: "Bestellung",
  carpet_show: "Teppich-Show",
  back_market: "Zurück zum Markt",
  next: "nächste",
  previous: "Vorherige",
  carpet_link: "Der Link des gewünschten Teppichs",
  national_Code: "Nationaler Kodex",
  upload_photo_and_video: "Laden Sie Fotos und Videos Ihres Teppichs hoch",
  photoـorـvideoـlink: "Foto- oder Videolink",
  coming_back: "zurück kommen",
  the_link_of_the_carpet_you_want: "Der Link des gewünschten Teppichs",
  landing_tab:
    "Verwenden Sie das obere Menü für eine vollständige Einführung in jeden Abschnitt und das untere Menü für einen schnelleren Zugriff.",
  carpet_replacement: "ersetzen",
  submit: "einreichen",
  receiving_information: "Informationen erhalten",
};
